import { FC } from "react";
import { Download } from "shared/assets/icons";
import { Button } from "shared/components";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";
import { copy } from "shared/assets";

const { calendar: calendarCopy } = copy;

interface ExportXlsButtonProps {
  handleClick: () => void;
}

export const ExportXlsButton: FC<ExportXlsButtonProps> = ({ handleClick }) => {
  return (
    <Button
      onClick={() => handleClick()}
      size="xs"
      theme={ITheme.secondary}
      data-testid="export_to_xls_button"
    >
      <Icon as={Download} />
      <span>{calendarCopy.xlsExport.title}</span>
    </Button>
  );
};
